<template>
	<div class="mySampleBorrowingClass">
		<div class="contentClass">
			<span class="spanInfor">请在下方对应上传样品借用配套资料</span>
			<div class="uploadClass">
				<el-form ref="borrowRef" style="width: 100%" :model="form" :rules="rules" label-width="220px">
					<!-- <el-form-item label="订单id" prop="sampleOrderId">
						<el-input v-model="form.sampleOrderId" :disabled="true" placeholder="请输入订单id" />
					</el-form-item> -->
					<el-form-item label="探月中心批复的样品借用申请表" prop="sampleBorrowApplication">
						<div style="display: flex">
							<el-input v-model="form.sampleBorrowApplication" required :disabled="true" clearable></el-input>
							<el-upload class="upload-demo" :headers="headers" :action="`${actionUrl}/common/upload`" :on-success="handleSuccessApplication" :before-upload="beforeUpload" multiple>
								<el-button size="small" type="primary">点击上传</el-button>
								<!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
							</el-upload>
						</div>
					</el-form-item>
					<el-form-item label="与探月中心签署样品借用协议" prop="sampleBorrowAgreement">
						<div style="display: flex">
							<el-input v-model="form.sampleBorrowAgreement" required :disabled="true" clearable></el-input>
							<el-upload class="upload-demo" :headers="headers" :action="`${actionUrl}/common/upload`" :on-success="handleSuccessAgreement" :before-upload="beforeUpload" multiple>
								<el-button size="small" type="primary">点击上传</el-button>
							</el-upload>
						</div>
					</el-form-item>
					<el-form-item label="其他文件" prop="otherDocuments">
						<div style="display: flex">
							<el-input v-model="form.otherDocuments" required :disabled="true" clearable></el-input>
							<el-upload class="upload-demo" :headers="headers" :action="`${actionUrl}/common/upload`" :on-success="handleSuccessotherDocuments" :before-upload="beforeUpload" multiple>
								<el-button size="small" type="primary">点击上传</el-button>
							</el-upload>
						</div>
					</el-form-item>
					<el-form-item label="身份证-正面" prop="usePersonIdJust" required>
						<el-upload
							:headers="headers"
							:action="`${actionUrl}/common/upload`"
							list-type="picture-card"
							:file-list="imageUrlListJust"
							:on-success="handleSuccessPersonIdJust"
							:before-upload="beforeUploadIMG"
							:on-preview="handlePictureCardPreview"
							:on-remove="handleRemove"
							:limit="1"
						>
							<i class="el-icon-plus"></i>
						</el-upload>
						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="dialogImageUrl" alt="" />
						</el-dialog>
						<div class="el-upload__tip" style="color: red">注：只能上传jpg/png文件,限制一张图片！</div>
					</el-form-item>
					<el-form-item label="身份证-反面" prop="usePersonIdBack" required>
						<el-upload
							:headers="headers"
							list-type="picture-card"
							:file-list="imageUrlListBack"
							:action="`${actionUrl}/common/upload`"
							:on-success="handleSuccessPersonIdBack"
							:before-upload="beforeUploadIMG"
							:on-preview="handlePictureCardPreview"
							:on-remove="handleRemove"
							:limit="1"
						>
							<i class="el-icon-plus"></i>
						</el-upload>
						<div class="el-upload__tip" style="color: red">注：只能上传jpg/png文件,限制一张图片！</div>

						<el-dialog :visible.sync="dialogVisible">
							<img width="100%" :src="dialogImageUrl" alt="" />
						</el-dialog>
					</el-form-item>
					<el-form-item label="备注" prop="remark">
						<el-input v-model="form.remark" type="textarea" :rows="4" placeholder="请输入备注" />
					</el-form-item>
				</el-form>
			</div>
			<!-- <div class="btnDivclass">
             <el-button class="btnClass" @click="submitSampleFunc()"> <i class="el-icon-check"></i>确定</el-button>
        </div> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'borrrowing',
	data() {
		return {
			imageUrlListJust: [],
			imageUrlListBack: [],
			actionUrl: window.dataManage.proPrefix,
			dialogImageUrl: '',
			dialogVisible: false,
			imageUrlJust: '',
			imageUrlBack: '',
			headers: {},
			importData: { imporType: 1 },
			authorization: '',
			fileName: null, // 用于存储文件名
			form: {
				sampleOrderId: '',
				sampleBorrowApplication: '',
				sampleBorrowAgreement: '',
				usePersonIdJust: '',
				usePersonIdBack: '',
				otherDocuments: '',
				remark: ''
			},
			rules: {
				sampleBorrowApplication: [{ required: true, message: '请上传探月中心批复的样品借用申请表', trigger: 'blur' }],
				sampleBorrowAgreement: [{ required: true, message: '请上传与探月中心签署样品借用协议', trigger: 'blur' }],
				usePersonIdJust: [{ required: true, message: '请上传身份证-正面', trigger: 'blur' }],
				usePersonIdBack: [{ required: true, message: '请上传身份证-反面', trigger: 'blur' }]
			}
		}
	},
	mounted() {
		this.authorization = this.$cookie.get('PIE_MALL_Token')
		this.headers = { Authorization: this.authorization }
	},
	methods: {
		handleRemove(file, fileList) {
			console.log(file, fileList)
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url
			this.dialogVisible = true
		},
		handleSuccess(response) {
			if (response.responseCode == 0) {
				this.$message.success(response.responseMsg)
			} else {
				this.$message.error(response.responseMsg)
			}
		},
		handleSuccessApplication(response, file, fileList) {
			this.form.sampleBorrowApplication = response.fileName
			this.submitSampleFunc()
		},
		handleSuccessotherDocuments(response, file, fileList) {
			this.form.otherDocuments = response.fileName
			this.submitSampleFunc()
		},
		handleSuccessAgreement(response, file, fileList) {
			this.form.sampleBorrowAgreement = response.fileName
			this.submitSampleFunc()
		},

		handleSuccessPersonIdJust(response, file, fileList) {
			let imgArr = []
			fileList.forEach((element) => {
				imgArr.push(response.fileName)
			})
			this.form.usePersonIdJust = imgArr.toString()
			this.submitSampleFunc()
		},
		handleSuccessPersonIdBack(response, file, fileList) {
			let imgArr = []
			fileList.forEach((element) => {
				imgArr.push(response.fileName)
			})
			this.form.usePersonIdBack = imgArr.toString()
			this.submitSampleFunc()
		},
		beforeUpload(file) {
			// const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png'
			// const isLt2M = file.size / 1024 / 1024 < 0.5; // 文件大小限制为500kb

			// if (!isJPGOrPNG) {
			// 	this.$message.error('上传图片只能是 JPG/PNG 格式!')
			// 	return false
			// }
			// if (!isLt2M) {
			//     this.$message.error('上传头像图片大小不能超过 500KB!');
			//     return false;
			// }
			return true // 返回 true 表示允许上传。
		},
		beforeUploadIMG(file) {
			const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png'
			// const isLt2M = file.size / 1024 / 1024 < 0.5; // 文件大小限制为500kb

			if (!isJPGOrPNG) {
				this.$message.error('上传图片只能是 JPG/PNG 格式!')
				return false
			}
			// if (!isLt2M) {
			//     this.$message.error('上传头像图片大小不能超过 500KB!');
			//     return false;
			// }
			return true // 返回 true 表示允许上传。
		},
		initForm(row) {
			this.imageUrlListBack = []
			this.imageUrlListJust = []
			this.form = row.sampleOrderBorrow
			// this.form.usePersonIdBack = 'http://10.1.200.142:30801/upload/2026/04/16/上网计算机 - 副本_20260416024521A001.png'
			this.imageUrlListBack.push({ name: row.sampleOrderBorrow.usePersonIdBack, url: row.sampleOrderBorrow.usePersonIdBack })
			this.form.usePersonIdBack = row.sampleOrderBorrow.usePersonIdBack
			this.imageUrlListJust.push({ name: row.sampleOrderBorrow.usePersonIdJust, url: row.sampleOrderBorrow.usePersonIdJust })
			this.form.usePersonIdJust = row.sampleOrderBorrow.usePersonIdJust
		},
		borrowInit(item) {
			this.form.sampleOrderId = item.sampleDataId
		},
		submitSampleFunc() {
			let that = this
			let objFlag = false
			this.$refs['borrowRef'].validate((valid) => {
				if (valid) {
					objFlag = that.form
				} else {
					objFlag = false
				}
			})
			return objFlag
			// let resBorrow = await this.$http.post(this.$const.moonSample.addBorrow, this.form);
			// if(resBorrow && resBorrow.code == 200){
			//     this.$message.success('提交成功')
			//     this.$refs['borrowRef'].resetFields();
			// }
			// this.$emit('borrowItemNext',  this.sampleObj)
		}
	}
}
</script>

<style lang="scss" scoped>
.mySampleBorrowingClass {
	padding: 0px 30px;
	background-color: #ffffff;
	// width: 1200px;
	// padding: 20px;
	min-height: 500px;
	.titleTypeClass {
		font-style: normal;
		display: block;
		font-family: MicrosoftYaHeiUISemibold;
		font-size: 28px;
		color: #000000;
		text-align: left;
		font-style: normal;
		position: absolute;
	}
	.titleDivClass {
		display: block;
		text-align: center;
		.span1Class {
			display: block;
			font-size: 24px;
		}
		.span2Class {
			margin-top: 16px;
			display: block;
			font-size: 26px;
		}
	}
	.contentClass {
		// margin-top: 20px;
		text-align: left;
		.spanInfor {
			color: #3a8ee6;
		}
		.uploadClass {
			margin-top: 20px;
			display: flex;
			justify-content: left;
		}
		.btnDivclass {
			text-align: center;
			margin-top: 20px;
			.btnClass {
				background: #15418c;
				border-radius: 4px;
				font-family: MicrosoftYaHeiUI;
				font-size: 16px;
				color: #ffffff;
				line-height: 21px;
				text-align: left;
				font-style: normal;
				line-height: 10px;
				text-align: left;
				font-style: normal;
				margin-top: 5px;
			}
		}
	}
}
</style>
<style>
.upload-demo .el-upload-list {
	display: none;
}
</style>
<style>
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
</style>
